export default __webpack_public_path__ + "static/media/Draft.137b4fad.svg";